import React from 'react';
import { Stack, Inline, Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { Breadcrumb } from './breadcrumb/index.tsx';
import FeedbackButton from './feedback-button/index.tsx';
import messages from './messages.tsx';

// AKPageHeader has a margin in the bottom that will requires to tell the list view that needs to remove the top margin
// thus, as we dont have actions, or complex title I choose to just use primitives.
export const PageHeader = () => {
	const { formatMessage } = useIntl();
	return (
		<Stack xcss={pageHeaderStyles}>
			<Breadcrumb />
			<Inline alignBlock="start">
				<Flex xcss={titleWrapperStyles}>{formatMessage(messages.listViewTitle)}</Flex>
				<Flex>
					<FeedbackButton />
				</Flex>
			</Inline>
		</Stack>
	);
};

const pageHeaderStyles = xcss({
	paddingTop: 'space.300',
});

const titleWrapperStyles = xcss({
	display: 'flex',
	maxWidth: '100%',
	overflow: 'hidden',
	flex: '1 1 auto',
	font: token('font.heading.large'),
});
